"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _dom = require("./dom");

var _data = require("./data");

var _is_js = _interopRequireDefault(require("is_js"));

var _events = require("./events");

var _style = require("./style");

var _ui = require("./ui");

var _Modal = _interopRequireDefault(require("../ui/Modal"));

var _variables = _interopRequireDefault(require("../variables"));

var APIName = _variables["default"].$EXTERNAL_API_NAME;
var functional = [{
  name: 'dom',
  value: _dom.$dom
}, {
  name: 'data',
  value: _data.$data
}, {
  name: 'is',
  value: _is_js["default"]
}, {
  name: 'events',
  value: _events.$events
}, {
  name: 'style',
  value: _style.$style
}, {
  name: 'ui',
  value: _ui.$ui
}, {
  name: 'ModalController',
  value: new _Modal["default"]({
    overlap: true
  })
}];

if (Boolean(window[APIName])) {
  console.warn('No global front API created! Specify a unique API name as an argument to the initGlobalApi function as a string');
} else {
  window[APIName] = {};
  functional.forEach(function (item) {
    return window[APIName][item.name] = item.value;
  });
}